import isEnumGenerator from '~/utils/isEnumGenerator';
import { PinCategory } from './enums';

export const isPinCategory = isEnumGenerator(PinCategory);
